import add from "./add.js";
/**
 * Increments its argument.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Math
 * @sig Number -> Number
 * @param {Number} n
 * @return {Number} n + 1
 * @see R.dec
 * @example
 *
 *      R.inc(42); //=> 43
 */

var inc =
/*#__PURE__*/
add(1);
export default inc;


//////////////////
// WEBPACK FOOTER
// ./~/ramda/es/inc.js
// module id = 1705
// module chunks = 1